import { render, staticRenderFns } from "./AdminPostActionsMenu.vue?vue&type=template&id=c73176ca"
import script from "./AdminPostActionsMenu.vue?vue&type=script&lang=js"
export * from "./AdminPostActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports